import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, resolveComponent as _resolveComponent, unref as _unref, isRef as _isRef, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createSlots as _createSlots, withModifiers as _withModifiers, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "highlighted-content-text" }
const _hoisted_2 = { class: "cluster info-columns" }
const _hoisted_3 = { class: "flow" }
const _hoisted_4 = { class: "info-columns__icon" }
const _hoisted_5 = { class: "flow" }
const _hoisted_6 = { class: "info-columns__icon" }
const _hoisted_7 = { class: "flow" }
const _hoisted_8 = { class: "info-columns__icon" }
const _hoisted_9 = { class: "sidebar icon-sidebar" }
const _hoisted_10 = { class: "sidebar icon-sidebar" }
const _hoisted_11 = { class: "sidebar icon-sidebar" }
const _hoisted_12 = { class: "content-card__content" }
const _hoisted_13 = {
  class: "callout flow",
  "data-borderless": ""
}
const _hoisted_14 = { class: "icon-list" }
const _hoisted_15 = { class: "icon-text" }
const _hoisted_16 = { class: "icon-text__icon" }
const _hoisted_17 = { class: "icon-text" }
const _hoisted_18 = { class: "icon-text__icon" }
const _hoisted_19 = { class: "icon-text" }
const _hoisted_20 = { class: "icon-text__icon" }
const _hoisted_21 = { class: "icon-text" }
const _hoisted_22 = { class: "icon-text__icon" }
const _hoisted_23 = { class: "icon-text" }
const _hoisted_24 = { class: "icon-text__icon" }
const _hoisted_25 = { class: "icon-text" }
const _hoisted_26 = { class: "icon-text__icon" }
const _hoisted_27 = { id: "membership-form-heading" }
const _hoisted_28 = { id: "membership-form-subheading" }
const _hoisted_29 = { id: "membership-form-subheading" }
const _hoisted_30 = { "aria-live": "polite" }
const _hoisted_31 = { class: "switcher" }

import { computed, ref } from 'vue';
import type { Country } from '@src/view_models/Country';
import type { CampaignValues } from '@src/view_models/CampaignValues';
import type { AddressValidation } from '@src/view_models/Validation';
import type { TrackingData } from '@src/view_models/TrackingData';
import type { Salutation } from '@src/view_models/Salutation';
import ContentCard from '@src/components/patterns/ContentCard.vue';
import Payment from '@src/components/pages/membership_form/Payment.vue';
import ErrorSummary from '@src/components/shared/ErrorSummary.vue';
import MembershipTypeField from '@src/components/pages/membership_form/MembershipTypeField.vue';
import AddressType from '@src/components/pages/membership_form/AddressType.vue';
import { useStore } from 'vuex';
import { useAddressTypeFunctions } from '@src/components/pages/membership_form/AddressTypeFunctions';
import { useMembershipTypeModel } from '@src/components/pages/membership_form/useMembershipTypeModel';
import { MembershipTypeModel } from '@src/view_models/MembershipTypeModel';
import { AddressTypeModel } from '@src/view_models/AddressTypeModel';
import { useMembershipFormSubmitHandler } from '@src/components/pages/membership_form/useMembershipFormSubmitHandler';
import { trackFormSubmission } from '@src/util/tracking';
import AddressFields from '@src/components/pages/membership_form/Address.vue';
import FormButton from '@src/components/shared/form_elements/FormButton.vue';
import SubmitValues from '@src/components/pages/membership_form/SubmitValues.vue';
import MembershipSummaryHeadline from '@src/components/pages/membership_form/MembershipSummaryHeadline.vue';
import Summary from '@src/components/patterns/Summary.vue';
import AddressSummarySection from '@src/components/shared/AddressSummarySection.vue';
import PaymentSummarySection from '@src/components/shared/PaymentSummarySection.vue';
import { useMembershipBankDataSummary } from '@src/components/pages/membership_form/useMembershipBankDataSummary';
import { useMembershipPaymentFunctions } from '@src/components/pages/membership_form/useMembershipPaymentFunctions';
import TickIcon from '@src/components/shared/icons/TickIcon.vue';
import DetailedInfoBox from '@src/components/patterns/DetailedInfoBox.vue';
import GlobeIcon from '@src/components/shared/icons/GlobeIcon.vue';
import BooksIcon from '@src/components/shared/icons/BooksIcon.vue';
import ShieldIcon from '@src/components/shared/icons/ShieldIcon.vue';
import SoftwareTechnologyIcon from '@src/components/shared/icons/SoftwareTechnologyIcon.vue';

interface Props {
	validateAddressUrl: string;
	validateEmailUrl: string;
	validateBankDataUrl: string;
	validateLegacyBankDataUrl: string;
	validateFeeUrl: string;
	paymentAmounts: number[];
	paymentIntervals: number[];
	paymentTypes: string[];
	countries: Country[];
	salutations: Salutation[];
	showMembershipTypeOption: Boolean;
	addressValidationPatterns: AddressValidation;
	dateOfBirthValidationPattern: String;
	campaignValues: CampaignValues;
	trackingData: TrackingData;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'MembershipForm',
  props: {
    validateAddressUrl: {},
    validateEmailUrl: {},
    validateBankDataUrl: {},
    validateLegacyBankDataUrl: {},
    validateFeeUrl: {},
    paymentAmounts: {},
    paymentIntervals: {},
    paymentTypes: {},
    countries: {},
    salutations: {},
    showMembershipTypeOption: {},
    addressValidationPatterns: {},
    dateOfBirthValidationPattern: {},
    campaignValues: {},
    trackingData: {}
  },
  setup(__props: any) {

const props = __props;
const store = useStore();

const addressFieldsRef = ref<HTMLFormElement>();
const { disabledAddressTypes, addressType, setAddressType, addressSummary } = useAddressTypeFunctions( store );
const { bankDataSummary } = useMembershipBankDataSummary( store );
const { paymentSummary } = useMembershipPaymentFunctions( store );
const membershipTypeModel = useMembershipTypeModel( store );
const disabledMembershipTypes = computed(
	(): MembershipTypeModel[] => {
		return store.state.membership_address.addressType === AddressTypeModel.COMPANY ? [ MembershipTypeModel.ACTIVE ] : [];
	}
);
const trackAddressForm = () => {
	trackFormSubmission( addressFieldsRef.value );
};
const isDirectDebitPayment = computed( (): boolean => store.state.membership_fee.values.type === 'BEZ' );

const {
	submit,
	submitValuesForm,
	showErrorSummary,
} = useMembershipFormSubmitHandler( store, isDirectDebitPayment, props.validateAddressUrl, props.validateEmailUrl, trackAddressForm );

const scrollToPaymentSection = () => {
	const scrollIntoViewElement = document.getElementById( 'membership-form-heading' );
	if ( scrollIntoViewElement ) {
		scrollIntoViewElement.scrollIntoView( { behavior: 'auto' } );
	}
};


return (_ctx: any,_cache: any) => {
  const _component_FeatureToggle = _resolveComponent("FeatureToggle")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("form", {
      action: "",
      onSubmit: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["prevent"]))
    }, [
      _createVNode(_component_FeatureToggle, { "default-template": "campaigns.membership_form.legacy" }, {
        "campaigns.membership_form.test_01_more_info": _withCtx(() => [
          _createVNode(ContentCard, {
            "is-collapsable": true,
            "is-flow": false
          }, {
            content: _withCtx(() => [
              _createVNode(DetailedInfoBox, { id: "membership-benefits-info-box" }, {
                heading: _withCtx(() => [
                  _createVNode(GlobeIcon, { class: "highlighted-icon" }),
                  _createElementVNode("h2", _hoisted_1, _toDisplayString(_ctx.$t('membership_form_detailed_info_box_heading')), 1)
                ]),
                "collapsed-content": _withCtx(() => [
                  _createElementVNode("p", null, _toDisplayString(_ctx.$t('membership_form_detailed_info_box_collapsed_info_text')), 1),
                  _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                      _createElementVNode("div", _hoisted_4, [
                        _createVNode(SoftwareTechnologyIcon, { class: "highlighted-icon" })
                      ]),
                      _createElementVNode("p", null, [
                        _createElementVNode("strong", null, _toDisplayString(_ctx.$t('membership_form_detailed_info_box_category_1')), 1),
                        _cache[3] || (_cache[3] = _createElementVNode("br", null, null, -1)),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('membership_form_detailed_info_box_category_1_headline')), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_5, [
                      _createElementVNode("div", _hoisted_6, [
                        _createVNode(ShieldIcon, { class: "highlighted-icon" })
                      ]),
                      _createElementVNode("p", null, [
                        _createElementVNode("strong", null, _toDisplayString(_ctx.$t('membership_form_detailed_info_box_category_2')), 1),
                        _cache[4] || (_cache[4] = _createElementVNode("br", null, null, -1)),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('membership_form_detailed_info_box_category_2_headline')), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("div", _hoisted_8, [
                        _createVNode(BooksIcon, { class: "highlighted-icon" })
                      ]),
                      _createElementVNode("p", null, [
                        _createElementVNode("strong", null, _toDisplayString(_ctx.$t('membership_form_detailed_info_box_category_3')), 1),
                        _cache[5] || (_cache[5] = _createElementVNode("br", null, null, -1)),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('membership_form_detailed_info_box_category_3_headline')), 1)
                      ])
                    ])
                  ])
                ]),
                "expanded-content": _withCtx(() => [
                  _createElementVNode("p", null, _toDisplayString(_ctx.$t('membership_form_detailed_info_box_expanded_info_text')), 1),
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", null, [
                      _createVNode(SoftwareTechnologyIcon, { class: "highlighted-icon" })
                    ]),
                    _createElementVNode("div", null, [
                      _createElementVNode("p", null, [
                        _createElementVNode("strong", null, _toDisplayString(_ctx.$t('membership_form_detailed_info_box_category_1')), 1),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('membership_form_detailed_info_box_category_1_headline')), 1)
                      ]),
                      _createElementVNode("p", null, _toDisplayString(_ctx.$t('membership_form_detailed_info_box_category_1_text_expanded')), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", null, [
                      _createVNode(ShieldIcon, { class: "highlighted-icon" })
                    ]),
                    _createElementVNode("div", null, [
                      _createElementVNode("p", null, [
                        _createElementVNode("strong", null, _toDisplayString(_ctx.$t('membership_form_detailed_info_box_category_2')), 1),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('membership_form_detailed_info_box_category_2_headline')), 1)
                      ]),
                      _createElementVNode("p", null, _toDisplayString(_ctx.$t('membership_form_detailed_info_box_category_2_text_expanded')), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", null, [
                      _createVNode(BooksIcon, { class: "highlighted-icon" })
                    ]),
                    _createElementVNode("div", null, [
                      _createElementVNode("p", null, [
                        _createElementVNode("strong", null, _toDisplayString(_ctx.$t('membership_form_detailed_info_box_category_3')), 1),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('membership_form_detailed_info_box_category_3_headline')), 1)
                      ]),
                      _createElementVNode("p", null, _toDisplayString(_ctx.$t('membership_form_detailed_info_box_category_3_text_expanded')), 1)
                    ])
                  ])
                ]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("h3", null, _toDisplayString(_ctx.$t( 'membership_form_reasons_title' )), 1),
                  _createElementVNode("ul", _hoisted_14, [
                    _createElementVNode("li", _hoisted_15, [
                      _createElementVNode("span", _hoisted_16, [
                        _createVNode(TickIcon, { class: "highlighted-icon" })
                      ]),
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t( 'membership_form_reasons_01' )), 1)
                    ]),
                    _createElementVNode("li", _hoisted_17, [
                      _createElementVNode("span", _hoisted_18, [
                        _createVNode(TickIcon, { class: "highlighted-icon" })
                      ]),
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t( 'membership_form_reasons_02' )), 1)
                    ]),
                    _createElementVNode("li", _hoisted_19, [
                      _createElementVNode("span", _hoisted_20, [
                        _createVNode(TickIcon, { class: "highlighted-icon" })
                      ]),
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t( 'membership_form_reasons_03' )), 1)
                    ]),
                    _createElementVNode("li", _hoisted_21, [
                      _createElementVNode("span", _hoisted_22, [
                        _createVNode(TickIcon, { class: "highlighted-icon" })
                      ]),
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t( 'membership_form_reasons_04' )), 1)
                    ]),
                    _createElementVNode("li", _hoisted_23, [
                      _createElementVNode("span", _hoisted_24, [
                        _createVNode(TickIcon, { class: "highlighted-icon" })
                      ]),
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t( 'membership_form_reasons_05' )), 1)
                    ]),
                    _createElementVNode("li", _hoisted_25, [
                      _createElementVNode("span", _hoisted_26, [
                        _createVNode(TickIcon, { class: "highlighted-icon" })
                      ]),
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t( 'membership_form_reasons_06' )), 1)
                    ])
                  ])
                ])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(ContentCard, null, {
        heading: _withCtx(() => [
          _createElementVNode("h1", _hoisted_27, _toDisplayString(_ctx.$t( 'membership_form_headline' )), 1),
          _createElementVNode("h2", _hoisted_28, _toDisplayString(_ctx.$t( 'membership_form_payment_subheading' )), 1)
        ]),
        content: _withCtx(() => [
          _createVNode(ErrorSummary, {
            "is-visible": _unref(showErrorSummary),
            items: [
						{
							validity: _unref(store).state.membership_fee.validity.interval,
							message: _ctx.$t( 'error_summary_interval' ),
							focusElement: 'interval-0',
							scrollElement: 'payment-form-interval',
						},
						{
							validity: _unref(store).state.membership_fee.validity.fee,
							message: _ctx.$t( 'error_summary_amount' ),
							focusElement: 'amount-500',
							scrollElement: 'payment-form-amount',
						},
						{
							validity: _unref(store).state.bankdata.validity.iban,
							message: _ctx.$t( 'donation_form_payment_iban_error' ),
							focusElement: 'iban',
							scrollElement: 'payment-form-iban',
						},
						{
							validity: _unref(store).state.membership_address.validity.salutation,
							message: _ctx.$t( 'donation_form_salutation_error' ),
							focusElement: 'salutation-0',
							scrollElement: 'address-form-salutation',
						},
						{
							validity: _unref(store).state.membership_address.validity.firstName,
							message: _ctx.$t( 'donation_form_firstname_error' ),
							focusElement: 'first-name',
							scrollElement: 'address-form-first-name',
						},
						{
							validity: _unref(store).state.membership_address.validity.lastName,
							message: _ctx.$t( 'donation_form_lastname_error' ),
							focusElement: 'last-name',
							scrollElement: 'address-form-last-name',
						},
						{
							validity: _unref(store).state.membership_address.validity.street,
							message: _ctx.$t( 'donation_form_street_error' ),
							focusElement: 'street',
							scrollElement: 'address-form-street',
						},
						{
							validity: _unref(store).state.membership_address.validity.postcode,
							message: _ctx.$t( 'donation_form_zip_error' ),
							focusElement: 'post-code',
							scrollElement: 'address-form-post-code',
						},
						{
							validity: _unref(store).state.membership_address.validity.city,
							message: _ctx.$t( 'donation_form_city_error' ),
							focusElement: 'city',
							scrollElement: 'address-form-city',
						},
						{
							validity: _unref(store).state.membership_address.validity.country,
							message: _ctx.$t( 'donation_form_country_error' ),
							focusElement: 'country',
							scrollElement: 'address-form-country',
						},
						{
							validity: _unref(store).state.membership_address.validity.date,
							message: _ctx.$t( 'membership_form_birth_date_error' ),
							focusElement: 'date',
							scrollElement: 'address-form-date-of-birth',
						},
						{
							validity: _unref(store).state.membership_address.validity.email,
							message: _ctx.$t( 'donation_form_email_error' ),
							focusElement: 'email',
							scrollElement: 'address-form-email',
						},
					]
          }, null, 8, ["is-visible", "items"]),
          (__props.showMembershipTypeOption)
            ? (_openBlock(), _createBlock(MembershipTypeField, {
                key: 0,
                modelValue: _unref(membershipTypeModel),
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(membershipTypeModel) ? (membershipTypeModel).value = $event : null)),
                disabledMembershipTypes: disabledMembershipTypes.value,
                "is-max-width-field": true
              }, null, 8, ["modelValue", "disabledMembershipTypes"]))
            : _createCommentVNode("", true),
          _createVNode(AddressType, {
            onFieldChanged: _cache[1] || (_cache[1] = ($event: any) => (_unref(setAddressType)( $event ))),
            disabledAddressTypes: _unref(disabledAddressTypes),
            "is-direct-debit": isDirectDebitPayment.value,
            "initial-address-type": _unref(addressType),
            "address-type-is-invalid": false,
            "is-max-width-field": true
          }, null, 8, ["disabledAddressTypes", "is-direct-debit", "initial-address-type"]),
          _createVNode(Payment, {
            "payment-amounts": __props.paymentAmounts,
            "payment-intervals": __props.paymentIntervals,
            "payment-types": __props.paymentTypes,
            "validate-fee-url": __props.validateFeeUrl.toString(),
            "validate-bank-data-url": __props.validateBankDataUrl.toString(),
            "validate-legacy-bank-data-url": __props.validateLegacyBankDataUrl.toString()
          }, null, 8, ["payment-amounts", "payment-intervals", "payment-types", "validate-fee-url", "validate-bank-data-url", "validate-legacy-bank-data-url"])
        ]),
        _: 1
      }),
      _createVNode(ContentCard, null, {
        heading: _withCtx(() => [
          _createElementVNode("h2", _hoisted_29, _toDisplayString(_ctx.$t( 'membership_form_address_subheading' )), 1)
        ]),
        content: _withCtx(() => [
          _createVNode(AddressFields, {
            "validate-address-url": __props.validateAddressUrl.toString(),
            "validate-email-url": __props.validateEmailUrl.toString(),
            countries: __props.countries,
            salutations: __props.salutations,
            "address-validation-patterns": __props.addressValidationPatterns,
            "date-of-birth-validation-pattern": __props.dateOfBirthValidationPattern,
            ref_key: "addressFieldsRef",
            ref: addressFieldsRef
          }, null, 8, ["validate-address-url", "validate-email-url", "countries", "salutations", "address-validation-patterns", "date-of-birth-validation-pattern"])
        ]),
        _: 1
      }),
      _createVNode(ContentCard, null, _createSlots({
        content: _withCtx(() => [
          (_unref(addressSummary) || _unref(bankDataSummary))
            ? (_openBlock(), _createBlock(Summary, { key: 0 }, _createSlots({ _: 2 }, [
                (_unref(addressSummary))
                  ? {
                      name: "left",
                      fn: _withCtx(() => [
                        _createVNode(AddressSummarySection, {
                          address: _unref(addressSummary),
                          countries: __props.countries,
                          salutations: __props.salutations
                        }, null, 8, ["address", "countries", "salutations"])
                      ]),
                      key: "0"
                    }
                  : undefined,
                (_unref(bankDataSummary))
                  ? {
                      name: "right",
                      fn: _withCtx(() => [
                        _createVNode(PaymentSummarySection, { "bank-data": _unref(bankDataSummary) }, null, 8, ["bank-data"])
                      ]),
                      key: "1"
                    }
                  : undefined
              ]), 1024))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_31, [
            _createVNode(FormButton, {
              id: "previous-btn",
              "is-outlined": true,
              onClick: scrollToPaymentSection
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('membership_form_section_back')), 1)
              ]),
              _: 1
            }),
            _createVNode(FormButton, {
              id: "submit-btn",
              "is-loading": _unref(store).getters.isValidating,
              onClick: _unref(submit)
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('membership_form_finalize')), 1)
              ]),
              _: 1
            }, 8, ["is-loading", "onClick"])
          ])
        ]),
        _: 2
      }, [
        (_unref(paymentSummary) || _unref(addressSummary) || _unref(bankDataSummary))
          ? {
              name: "heading",
              fn: _withCtx(() => [
                _createElementVNode("h2", _hoisted_30, _toDisplayString(_ctx.$t( 'form_summary_title' )), 1),
                (_unref(paymentSummary))
                  ? (_openBlock(), _createBlock(MembershipSummaryHeadline, {
                      key: 0,
                      paymentSummary: _unref(paymentSummary)
                    }, null, 8, ["paymentSummary"]))
                  : _createCommentVNode("", true)
              ]),
              key: "0"
            }
          : undefined
      ]), 1024)
    ], 32),
    _createElementVNode("form", {
      action: "/apply-for-membership",
      method: "post",
      ref_key: "submitValuesForm",
      ref: submitValuesForm,
      id: "submit-form"
    }, [
      _createVNode(SubmitValues, {
        "campaign-values": __props.campaignValues,
        "tracking-data": __props.trackingData
      }, null, 8, ["campaign-values", "tracking-data"])
    ], 512)
  ], 64))
}
}

})